import React from 'react';
import { render } from 'react-dom';
import Cuts from './apps/Cuts/Cuts';

// Cuts Application
const cuts = document.getElementById('cuts-app');
if (cuts) render(<Cuts {...cuts.dataset} />, cuts);
